import { Link } from 'react-router-dom';
import {
  CloseIcon,
  FairdropLogo,
  GithubIcon,
  XIcon,
  DatafundIcon,
} from './Icons';

interface MenuProps {
  isOpen: boolean;
  onClose: () => void;
  isLoggedIn?: boolean;
  username?: string;
  balance?: string;
  onLogout?: () => void;
}

export function Menu({
  isOpen,
  onClose,
  isLoggedIn = false,
  username,
  balance,
  onLogout,
}: MenuProps) {
  return (
    <>
      {/* Overlay */}
      <div
        className={`sidebar-overlay ${isOpen ? 'open' : ''}`}
        onClick={onClose}
        aria-hidden="true"
      />

      {/* Sidebar */}
      <nav
        className={`sidebar ${isOpen ? 'open' : ''}`}
        aria-label="Main navigation"
      >
        <div className="sidebar-header">
          <button className="icon-btn" onClick={onClose} aria-label="Close menu">
            <CloseIcon />
          </button>
          <FairdropLogo />
          <div style={{ width: 24 }} /> {/* Spacer for centering */}
        </div>

        <div className="sidebar-content">
          {!isLoggedIn ? (
            <>
              <Link to="/account" className="menu-item" onClick={onClose}>
                Login &gt;
              </Link>
              <Link to="/upload?mode=quick" className="menu-item" onClick={onClose}>
                Quick Share
              </Link>
              <Link to="/upload?mode=send" className="menu-item" onClick={onClose}>
                Send Encrypted
              </Link>
              <Link to="/upload?mode=store" className="menu-item" onClick={onClose}>
                Store File
              </Link>
              <div className="menu-divider" />
              <Link to="/about" className="menu-item" onClick={onClose}>
                About &gt;
              </Link>
              <Link to="/about#agents" className="menu-item" onClick={onClose}>
                For Agents
              </Link>
            </>
          ) : (
            <>
              <Link to="/upload?mode=quick" className="menu-item" onClick={onClose}>
                Quick Share
              </Link>
              <Link to="/upload?mode=send" className="menu-item" onClick={onClose}>
                Send Encrypted
              </Link>
              <Link to="/upload?mode=store" className="menu-item" onClick={onClose}>
                Store File
              </Link>
              <div className="menu-divider" />
              <Link to="/account/received" className="menu-item" onClick={onClose}>
                Inbox
              </Link>
              <Link to="/account/sent" className="menu-item" onClick={onClose}>
                Sent
              </Link>
              <Link to="/account/stored" className="menu-item" onClick={onClose}>
                Stored
              </Link>
              <div className="menu-divider" />
              <Link to="/settings" className="menu-item" onClick={onClose}>
                Settings
              </Link>
              <div className="menu-divider" />
              <Link to="/about" className="menu-item" onClick={onClose}>
                About &gt;
              </Link>
              <Link to="/about#agents" className="menu-item" onClick={onClose}>
                For Agents
              </Link>
              <div className="menu-divider" />
              {username && (
                <div className="menu-item" style={{ opacity: 0.7 }}>
                  <span style={{ marginRight: 8 }}>👤</span>
                  {username}{balance ? ` (${balance})` : ''}
                </div>
              )}
              <button
                className="menu-item"
                onClick={() => {
                  if (onLogout) {
                    onLogout();
                  }
                  onClose();
                }}
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  width: '100%',
                  textAlign: 'left',
                }}
              >
                Log Out
              </button>
            </>
          )}
        </div>

        <div className="sidebar-footer">
          <a
            href="https://github.com/fairDataSociety/fairdrop"
            target="_blank"
            rel="noopener noreferrer"
            className="icon-btn"
            aria-label="GitHub"
          >
            <GithubIcon />
          </a>
          <a
            href="https://x.com/faaborot"
            target="_blank"
            rel="noopener noreferrer"
            className="icon-btn"
            aria-label="X (Twitter)"
          >
            <XIcon />
          </a>
          <a
            href="https://datafund.io"
            target="_blank"
            rel="noopener noreferrer"
            className="icon-btn"
            aria-label="Datafund"
          >
            <DatafundIcon />
          </a>
        </div>
      </nav>
    </>
  );
}
